export enum ClientExtractLoanPartCollectionIntervalEnum {
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  Halfyearly = 'Halfyearly',
  Yearly = 'Yearly',
}
